export const labelStyle = {
    fontFamily: "Outfit, sans-serif",
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: "0px",
    mb: 0,
    color: "#111827",
};

export const subTextStyle = {
    fontFamily: "Outfit, sans-serif",
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: "140%",
    color: "#7D7F81",
    letterSpacing: "0px",
};
